import styled from 'styled-components';
import { palette } from 'styled-theme';

export const NavbarContainer = styled.nav`
  position: fixed;
  width: 100%;
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${palette('background', 0)};
  padding: 0 32px;
  z-index: 100;
  transition: left 0.3s ease;
  border-bottom: 1px solid ${palette('border', 1)};
  box-shadow: 2px 0 10px rgba(99, 102, 241, 0.15);
`;

export const Logo = styled.div`
  font-family: 'Manrope', sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: #6366f1;
  letter-spacing: -0.6px;
  line-height: 32px;
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
`;

export const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fffbff;
  cursor: pointer;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: 50px;
  right: 0;
  width: 224px;
  background-color: ${palette('background', 3)};
  backdrop-filter: blur(12px);
  border-radius: 8px;
  border: 1px solid rgba(199, 196, 215, 0.15);
  box-shadow: 0px 20px 50px 0px rgba(26, 27, 36, 0.06);
  overflow: hidden;
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  transform: ${(props) => (props.isOpen ? 'translateY(0)' : 'translateY(-10px)')};
  transition:
    opacity 0.2s ease,
    transform 0.2s ease,
    visibility 0.2s ease;
  z-index: 1000;
`;

export const DropdownHeader = styled.div`
  padding: 12px 16px 13px;
  border-bottom: 1px solid rgba(199, 196, 215, 0.1);
`;

export const UserName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1a1b24;
  line-height: 20px;
  text-transform: capitalize;
`;

export const UserRole = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: #464554;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 15px;
`;

export const DropdownBody = styled.div`
  padding: 4px 0;
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  font-size: 14px;
  color: #464554;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(99, 102, 241, 0.05);
  }

  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
  }
`;

export const DropdownFooter = styled.div`
  border-top: 1px solid rgba(199, 196, 215, 0.1);
  padding-top: 5px;
`;

export const LogoutButton = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  font-family: 'Manrope', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #ba1a1a;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(186, 26, 26, 0.05);
  }

  svg {
    width: 13.5px;
    height: 13.5px;
    flex-shrink: 0;
  }
`;
